import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.title',
    defaultMessage: 'Release files to customer',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.loading',
    defaultMessage: 'Releasing..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.submit',
    defaultMessage: 'Release',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.sideEffects',
    defaultMessage: `
      <li>This will release all visible files to the customer</li>
      <li>Primary and secondary contact MIGHT be notified, depending on customer-level preferences and contacts individual preferences</li>
      <li>Further files can be released by uploading and making those visibile</li>
    `
  },
  bypassWarning: {
    id: 'containers.OrderPage.components.TaskPage.components.ShowCustomerNoteDialog.bypassWarning',
    defaultMessage: 'As you have enabled the "Bypass Customer Notification" automation, your customer will NOT be notified about this, and therefore you should notify your customer manually.'
  },
})
